import { render, staticRenderFns } from "./Solicitados.vue?vue&type=template&id=e4f16f66&scoped=true&"
import script from "./Solicitados.vue?vue&type=script&lang=js&"
export * from "./Solicitados.vue?vue&type=script&lang=js&"
import style0 from "./Solicitados.vue?vue&type=style&index=0&id=e4f16f66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f16f66",
  null
  
)

export default component.exports